import { Attributes, List, ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';
import BankDetail from '../../ValueObjects/BankDetail';
import BankAccountBalance from './BankAccountBalance';

@NeoModel
export default class BankAccount extends ModelBase {
    static typeName = "BankAccount";

    public bankAccountId: number = 0;

    @Attributes.ChildObject(BankDetail, true)
    public values: BankDetail = new BankDetail();

    @Attributes.ChildList(BankAccountBalance)
    public bankAccountBalances = new List(BankAccountBalance);

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New bank account";
        } else {
            return "Bank Account";
        }
    }
}